<template>
  <b-modal
    id="confirmationMultipleInvoice"
    hide-footer
    hide-header
    centered
    content-class="!rounded-[8px] overflow-hidden"
  >
    <div>
      <div class="-mt-[0.8rem] -mx-[1.4rem] flex gap-[8px] items-center bg-[#F8F8F8] h-[48px] sm:h-[56px] px-[1.4rem] sm:px-[20px] font-medium text-[12px] sm:text-[16px] text-[#333]">
        <i class="k-info-circle-1 text-[16px] sm:text-[24px] font-semibold" />
        Talent Sudah Memiliki Invoice
      </div>
      <div class="sm:px-[7px] pt-[16px] sm:pt-[24px]">
        <p class="text-[12px] sm:text-[16px] text-[#333] m-0">
          Talent berikut sudah memiliki invoice pada partner dan periode yang sama:
        </p>
        <div class="my-[16px] sm:my-[24px] py-[12px] sm:py-[16px] px-[16px] sm:px-[20px] bg-[#FFECE9] rounded-[4px]">
          <div class="pb-[10px]">
            <div class="flex gap-[2px] sm:gap-[4px] text-[12px] sm:text-[14px]">
              <span class="min-w-[103px] sm:min-w-[126px] text-[#626262]">Partner</span>
              <b class="font-semibold text-[#333]"> : </b>
              <b class="font-semibold text-[#333]">{{ partnerName }}</b>
            </div>
            <div class="mt-[6px] sm:mt-[8px] flex gap-[2px] sm:gap-[4px] text-[12px] sm:text-[14px]">
              <span class="min-w-[103px] sm:min-w-[126px] text-[#626262]">Periode Invoice</span>
              <b class="font-semibold text-[#333]"> : </b>
              <b class="font-semibold text-[#333]">{{ NODASH_MONTH_YEAR(periode) }}</b>
            </div>
          </div>
          <div class="px-[10px] py-[6px] sm:px-[14px] bg-white overflow-y-auto max-h-[260px] rounded-[4px]">
            <div
              v-for="talent, idx in listTalent"
              :key="idx"
              class="flex py-[8px] flex-wrap gap-x-[16px] gap-y-[8px] items-center justify-between !border-b border-[#E2E2E2] last:border-none"
            >
              <div class="flex flex-col gap-[4px] sm:gap-[6px] grow basis-w-[160px]">
                <b class="text-[14px] sm:text-[16px] text-[#333] font-semibold truncate">{{ talent.talent_name }}</b>
                <span class="text-[12px] text-[#626262]"><b class="font-bold text-[#F95031]">{{ talent.total_invoice }}</b> Invoice</span>
              </div>
              <div class="flex justify-end grow">
                <a
                  :href="getInvoiceUrl(talent)"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="px-[10px] h-[28px] sm:h-[32px] !border border-[#F95031] rounded-[6px] text-[10px] sm:text-[12px] whitespace-nowrap flex items-center
                  gap-[6px] sm:gap-[10px] !text-[#F95031] font-medium hover:bg-[#F95031]/5 active:bg-[#F95031]/20 transition-colors duration-300"
                >
                  Invoice Sebelumnya
                  <i class="k-arrow-right-3 text-[16px] sm:text-[20px]" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <p class="text-[12px] sm:text-[16px] text-[#828282] mb-[16px] sm:mb-[24px]">
          Menambahkan talent ini akan memasukkan talent ke invoice yang sedang dibuat.
        </p>
      </div>
      <div class="pb-[11px] sm:px-[19px] flex flex-wrap gap-y-[8px] gap-x-[12px] items-center">
        <b-button
          variant="outline-primary"
          class="grow basis-[115px]"
          @click="$bvModal.hide('confirmationMultipleInvoice')"
        >
          Batalkan
        </b-button>
        <b-button
          variant="primary"
          class="grow basis-[115px]"
          @click="handleConfirm"
        >
          Lanjutkan
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { NODASH_MONTH_YEAR } from '@/libs/filterDate'

export default {
  props: {
    listTalent: {
      type: Array,
      default: () => [],
    },
    partnerName: {
      type: String,
      default: '',
    },
    periode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      NODASH_MONTH_YEAR,
    }
  },
  methods: {
    getInvoiceUrl(talent) {
      return `${window.location.origin}/invoices-admin/${talent.invoice_id}/disbursement${talent.status === 'paid' ? '/monitor' : ''}`
    },
    handleConfirm() {
      this.$emit('confirm')
      this.$bvModal.hide('confirmationMultipleInvoice')
    },
  },
}
</script>
